/* globals axios, ca */
import { has } from 'lodash';
import VueI18n from 'vue-i18n';

import { projectRoute } from '@/helper/url';
import { deepen } from '@/helper/array';

// Language bundle
import languageBundle from '@kirschbaum-development/laravel-translations-loader?parameters={$1}!@kirschbaum-development/laravel-translations-loader';

const i18n = new VueI18n({
    locale: window.Locale,
    messages: languageBundle,
});

// project localization message overrides
if (has(ca, 'project')) {
    axios.get(projectRoute('projects.localization-messages')).then((response) => {
        for (const locale in response.data) {
            for (const [key, value] of Object.entries(response.data[locale])) {
                const obj = deepen({[key]: value});
                i18n.mergeLocaleMessage(locale, obj);
            }
        }
    });
}

export {
    i18n,
    languageBundle,
}
